<template>
  <div class="dynamic-form-step">
    <div class="dynamic-form-content">
      <!-- Title -->
      <div class="title-section">
        <h2 class="step-title">{{ step.title }}</h2>
      </div>

      <!-- Dynamic Form Fields -->
      <div class="form-fields">
        <div
          v-for="field in step.fields"
          :key="field.id"
          class="field-group"
        >
          <label class="field-label">
            {{ field.label }}
            
          </label>
          
          <!-- Input Field -->
          <InputText
            v-if="field.type === 'input'"
            v-model="fieldValues[field.id]"
            :placeholder="field.placeholder || ''"
            class="field-input"
            @update:model-value="() => updateField(field.id)"
          />
          
          <!-- Select Field -->
          <Select
            v-else-if="field.type === 'select'"
            v-model="fieldValues[field.id]"
            :options="field.options"
            optionLabel="label"
            optionValue="value"
            :placeholder="field.placeholder || 'Выберите'"
            class="field-select"
            @update:model-value="() => updateField(field.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import InputText from 'primevue/inputtext'
import Select from 'primevue/select'
import { useLookModal } from '@/features/look/store'
import type { LookStep } from '@/features/look/types/look-config'

interface Props {
  step: LookStep & { type: 'dynamic_form' }
}

const props = defineProps<Props>()
const lookStore = useLookModal()

const fieldValues = ref<Record<string, any>>({})

function updateField(fieldId: string) {
  const fieldKey = `${props.step.id}_${fieldId}`
  lookStore.updateLookData(fieldKey, fieldValues.value[fieldId])
}

onMounted(() => {
  const data = lookStore.lookModal.lookData
  
  // Загружаем сохраненные значения для всех полей
  props.step.fields.forEach(field => {
    const fieldKey = `${props.step.id}_${field.id}`
    const savedValue = data[fieldKey]
    fieldValues.value[field.id] = savedValue || null
  })
})
</script>

<style scoped>
.dynamic-form-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.dynamic-form-content {
  max-width: 500px;
  width: 100%;
}

.title-section {
  margin-bottom: 32px;
  text-align: center;
}

.step-title {
  font-size: 24px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 12px 0;
}

.step-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 14px;
  font-weight: 500;
  color: #1d1d1f;
}

.required-mark {
  color: #ff3b30;
}

.field-input,
.field-select {
  width: 100%;
}
</style>

